export const checkIsSaltPhRx = (model) => {
  return model === 'IWSALT1';
};

export const checkIsSaltPhRxPhRx = (model) => {
  return model === 'IWSALT2';
};

export const checkIsSaltPhRxCl = (model) => {
  return model === 'IWSALT3';
};

// Method used to check if a given model is a salt device
export const checkIsSalt = (model) => {
  return checkIsSaltPhRx(model) || checkIsSaltPhRxPhRx(model) || checkIsSaltPhRxCl(model);
};
